class ProductStrip extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-product-strip-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            init: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: '[data-product-strip-next]',
                prevEl: '[data-product-strip-prev]',
            },
            autoplay: {
                delay: 10000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
            }
        });

        this.swiper.on('resize init', (instance) => {
            this.swiperEl.classList.toggle('slider-active', instance.virtualSize > instance.size);
        });

        this.swiper.init();

        document.addEventListener('tab-shown', () => {
            setTimeout(() => this.swiper.update(), 50);
        });
    }
}
